/**
 * Kumpulan rules yang digunakan untuk field-field yang ada pada form
 */
"use strict";

// import store from './../store/index'

// const minPasswd = store.getters.PANJANG_MIN_PASSWD
// const minLogin = store.getters.PANJANG_MIN_LOGIN
// store.state.rules.find(el => el.key === 'PANJANG_MIN_PASSWD').value
// store.state.rules.find(el => el.key === 'PANJANG_MIN_PASSWD').value

const rules = {
  required: value => !!value || 'Field harus diisi!.',
  requiredCabang: cabang => value => ((!!value && cabang) || (!cabang)) || 'Field harus diisi!.',
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Pastikan alamat email Anda benar!'
  },
  number: value => {
    const pattern = /(\d+(\.\d+)?)/
    return pattern.test(value) || 'Saham harus diisi dengan angka !'
  },
  passwordConfirm: (pass) => (value) => value === pass || 'Password harus sama',
  pkp: value => {
    return ((value == '' && this.skPkp != null) || (!!value)) || 'No PKP atau upload Surat Keterangan harus dilampirkan'
  },
  skPkp: value => {
    return ((value == null && this.pkp != '') || (value != null)) || 'No PKP atau upload Surat Keterangan harus dilampirkan'
  },
}

module.exports = { rules }
